import { EWebhookEvent } from '../services/webhook.service';

/// Eventos que o CRM sabe avisar, na ordem do enum, para a lista não mudar a cada render.
export const WEBHOOK_EVENTS: { value: EWebhookEvent; key: string }[] = [
    { value: EWebhookEvent.LeadCreated, key: 'webhooks.leadCriado' },
    { value: EWebhookEvent.LeadMoved, key: 'webhooks.leadMovido' },
    { value: EWebhookEvent.LeadWon, key: 'webhooks.leadGanho' },
    { value: EWebhookEvent.LeadLost, key: 'webhooks.leadPerdido' },
    { value: EWebhookEvent.LeadAssigned, key: 'webhooks.leadAtribuido' },
];
